import React, {useContext, useEffect, useMemo, useRef, useState} from "react";
import NumberFormat from 'react-number-format';
import {Col, Container, Form, Overlay, Row} from "react-bootstrap";
import {AgGridReact} from "ag-grid-react";
import ActionsRenderer from "components/ActionsRenderer";
import useWindowDimensions from "hooks/Dimensions";
import * as URL from "service/UrlConstant";
import {SecurityContext} from "context/security";
import {dateToString, getCurrentDate, getCurrentDateToDatePickerFormat} from "utils/FormatUtils";
import {EntityAccountsContext} from "components/entity-accounts/context";
import {EntityAccountsComponent} from "components/entity-accounts/EntityAccountsComponent";
import {TradeBreakContext, TradeCaptureContext} from "./context";
import {TRADE_CAPTURE_PANEL_ENTRY_RESULT} from "./context/TradeCaptureContext";
import AccountTypeRenderer from './AccountTypeDropdownRenderer'
import {ToastContext} from "context/Toast";
import {useHistory} from "react-router-dom";
import * as Routes from "routes/Routes";
import {
    DEFAULT_GRID_PAGINATION_SIZE,
    REGEX_DECIMAL_MATCH,
    REGEX_TRADE_ENTRY_BROKER_CODE,
    REGEX_TRADE_ENTRY_CLIENT_ID, REGEX_TRADE_ENTRY_COMMENTS,
    REGEX_TRADE_ENTRY_COMMISSION_TYPE,
    REGEX_TRADE_ENTRY_CURRENCY,
    REGEX_TRADE_ENTRY_DECIMAL_NUMBER,
    REGEX_TRADE_ENTRY_SECURITY_CODE,
    LIST_TRADE_ENTRY_TRADE_TYPE,
    REGEX_TRADE_ENTRY_WHOLE_NUMBER, VALIDATION_IN_JS, GRID_COLUMN_PROPERTY,
    REGEX_TRADE_ENTRY_WHOLE_NUMBER_COMMA_OPTIONAL, MAX_LIMIT_TRADE_AMOUNT,MAX_LIMIT_TRADE_QUANTITY
} from "utils/Constants";
import {cellAlignment, numberFormat, formatAmount,  numberFormat5FractionalDigits} from "../../utils/NumberUtils";
import {validateValueOnRegex, validateValueOnList} from "../../utils/RegexUtils";
import {
    TRADE_ENTRY_BROKER_CODE_MSG,
    TRADE_ENTRY_CLIENT_ID_MSG, TRADE_ENTRY_COMMENTS_MSG,
    TRADE_ENTRY_COMMISSION_TYPE_MSG,
    TRADE_ENTRY_CURRENCY_MSG,
    TRADE_ENTRY_DECIMAL_NUMBER_MSG,
    TRADE_ENTRY_SECURITY_CODE_MSG,
    TRADE_ENTRY_TRADE_TYPE_MSG,
    TRADE_ENTRY_WHOLE_NUMBER_MSG,
    TRADE_ENTRY_TECH_SHORT_TRADE_TYPE_MSG,
} from "../../utils/ConstantsMsg";
import {getAllErrorValuesAsString} from "../../utils/ErrorUtils";
import {addPropertiesToGridColumns} from "../../utils/gridColumnUtils";
import LabelOverLay from "../../components/LabelOverLay";


const tradeTypeJSON = [
    { "id": "B", "name": "Buy" },
    { "id": "S", "name": "Sell" },
    { "id": "SS", "name": "Short Sale" },
    { "id": "BC", "name": "Buy Cover" },
];

const commissionTypeJSON = [
    { "id": "3", "name": "Total" },   //cash
    { "id": "1", "name": "Rate" },  //cps cents per share
    { "id": "5", "name": "Basis Points" },  // Basis Points : 100 pts = 1%
];

export default function TradeEntry() {

    const {tradeCaptureDisplayState, setTradeCaptureDisplayState, clearTradeSearchAndLoadTradingHome, clearTradeEntry, setAmendClicked} = useContext(TradeCaptureContext);
    const {highlightTradeEntryFields, viewClicked, setViewClicked} = useContext(TradeBreakContext);
    const [isTechShortChecked, setIsTechShortChecked] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [errors, setErrors] = useState({});
    const [isDisabled, setIsDisabled] = useState(false);
    const [isDisabledTechShort, setIsDisabledTechShort] = useState(true);
    const {entityAccountsNoSwap, showAccounts, setShowAccounts, validateEntityAccountSearch, clearEntityAccounts, accountsOptionsNoSwap, setManagerDetailsWithOptionalAccount, entityAccountsOptionsNoSwap, populateDefaultEntity} = useContext(EntityAccountsContext);
    const {makePostRequest, makeGetRequest, makeGetRequestNoParams} = useContext(SecurityContext)
    const {success, error} = useContext(ToastContext);
    const {isMobile} = useWindowDimensions();
    const myGrid = useRef(null);
    let history = useHistory();
    const [currencies, setCurrencies] = useState([]);
    const [secOption, setSecOption] = useState('');
    const [showToolTip, setShowToolTip] = useState(true);
    const target = useRef(null);
    const tradeDateLabelRef = useRef(null);
    const settleDateLabelRef = useRef(null);
    const priceLabelRef = useRef(null);
    const quantityLabelRef = useRef(null);
    const interestLabelRef = useRef(null);
    const commissionLabelRef = useRef(null);
    const brokerCodeLabelRef = useRef(null);
    let id = tradeCaptureDisplayState.tradeEntry.status;
    let isTradeBreak = tradeCaptureDisplayState.tradeEntry.isTradeBreak;
    const missMatched = "Conflict with StreetSide"
    function navigateToPage(path) {
        history.push(path);
    }

    const autoGroupColumnDef = useMemo(() => {
        return {
            maxWidth: 0,
            cellRendererParams: {
                suppressCount: true
            }
        };
    }, []);

    const defaultColDef = {
        sortable:true,
        resizable:true,
        floatingFilter:true,
        filter:true,
        enableCellChangeFlash:true,
        lockPinned:!!isMobile,
    };

    const columnTypes ={
        flexColType: {
            sortable: false,
            resizable: false,
            floatingFilter: false,
            filter: false,
            enableCellChangeFlash: false,
            suppressMenu:true,
            flex:1,
            suppressMovable:true,
            suppressColumnsToolPanel:true
        }
    }

    const allocationSum = (params) => {
        let total = 0;
        params.values.forEach(value => total += value);
        tradeCaptureDisplayState.tradeEntry.totalAllocation = total
        return total;
    }

    const setAllocation = (params) => {
        if(params.oldValue !== params.newValue) {
            params.data.allocation = parseFloat(params.newValue);
            getCommission(params);
            getAccruedInterest(params);

            let gridData = rowData.flatMap(item => {
                let accountAllocationObj
                if (item.accountId === params.data.accountId){
                    accountAllocationObj = {...item,...{
                            'allocation': JSON.parse(JSON.stringify(params.data.allocation)),
                        }}
                }
                else accountAllocationObj = item;
                return accountAllocationObj
            })
            setRowData(gridData)

            return true;
        }
        return false
    }

    const getCommission = (params) =>{

        //const {commission, commissionType, quantity, price} = tradeCaptureDisplayState.tradeEntry;
        const {commissionType} = tradeCaptureDisplayState.tradeEntry;
        const commission = formatAmount(tradeCaptureDisplayState.tradeEntry.commission)
        const price = formatAmount(tradeCaptureDisplayState.tradeEntry.price)
        const quantity = formatAmount(tradeCaptureDisplayState.tradeEntry.quantity)
        const allocation = params.data.allocation
        let total = 0.0;
        if (commission > 0 && allocation > 0) {
            if (commissionType === "3" || commissionType === "Total") {
                total = parseFloat(((commission * allocation) / quantity).toFixed(6));
            } else if (commissionType === "1" || commissionType === "Rate") {
                total = commission / 1
            }
            else if (commissionType === "5" || commissionType === "Basis Points") {
                total = commission / 1
            }
            params.data.commission = total;
            return total;
        }

        return 0
    }

    useEffect(() => {
        let gridData = rowData.flatMap(item => {
            let accountAllocationObj
            let returnObject = {
                data:{
                    item}};
            if (item.commission){
                accountAllocationObj = {...item,...{
                        'commission': JSON.parse(JSON.stringify(getCommission(returnObject))),
                    }}
            }
            else accountAllocationObj = item;
            return accountAllocationObj
        })
        setRowData(gridData)
    }, [tradeCaptureDisplayState.tradeEntry.commission])

    const getAccruedInterest = (params) =>{
        const quantity = formatAmount(tradeCaptureDisplayState.tradeEntry.quantity)
        const accruedInterest = formatAmount(tradeCaptureDisplayState.tradeEntry.accruedInterest)
        let total = 0;
        if(accruedInterest && quantity) {
            total = parseFloat(((accruedInterest * params.data.allocation) / quantity).toFixed(6))
            params.data.accruedInterest = total
            return total
        }
        return 0
    }

    const onAccountTypeChange = (accountType, rowIndex) => {
        rowData[rowIndex-1].accountType = accountType;
    }

    const columnDefs = [
        {headerName: '', field: 'accountId', hide:true, suppressColumnsToolPanel:true},
        {headerName: '', field: 'managerId', hide:true, suppressColumnsToolPanel:true, rowGroup: true},
        {headerName: 'Name', field: 'accountName',aggFunc:()=>"Total"},
        {headerName: 'Account', field: 'accountCode'},
        {headerName: 'Type', field: 'accountType', cellRenderer: 'accountTypeRenderer', cellRendererParams: {onAccountTypeChange: onAccountTypeChange}},
        {headerName: 'Allocation', field: 'allocation', editable:!isDisabled, valueSetter: setAllocation, aggFunc:allocationSum,cellStyle: cellAlignment, valueFormatter: numberFormat},
        {headerName: 'Commission', field: 'commission', valueGetter:getCommission, aggFunc:'sum',cellStyle: cellAlignment, valueFormatter: numberFormat5FractionalDigits},
        {headerName: 'Accrued Interest', field: 'accruedInterest',valueGetter:getAccruedInterest, aggFunc:'sum',cellStyle: cellAlignment, valueFormatter: numberFormat5FractionalDigits},
        {headerName: '', field: 'tradeBridgeTradeId', hide:true, suppressColumnsToolPanel: true},
        {headerName: '', field: 'clientId', hide:true, suppressColumnsToolPanel: true},
        {headerName: '', field: 'cdBlockIdClient', hide:true, suppressColumnsToolPanel: true},
        {headerName: '', field: '', type: 'flexColType', suppressColumnsToolPanel: true},
    ];

    const updatedColumnDefs = addPropertiesToGridColumns(columnDefs, GRID_COLUMN_PROPERTY)

    useEffect(() => {
        setShowAccounts(false,true)
    }, [entityAccountsOptionsNoSwap])

    useEffect(() => {
        populateDefaultEntity(showAccounts,true)
    }, [entityAccountsOptionsNoSwap])

    useEffect(() => {
        setIsTechShortChecked(tradeCaptureDisplayState.tradeEntry.techShort === 'Y');
    }, [tradeCaptureDisplayState.tradeEntry.techShort]);

    useEffect(() => {
        if(!viewClicked && isTradeBreak) return;
        if (tradeCaptureDisplayState.tradeEntry.managerId == null || tradeCaptureDisplayState.tradeEntry.managerId == "") {
            return;
        }

        let managerInfo = entityAccountsOptionsNoSwap.filter(item => item.managerId === tradeCaptureDisplayState.tradeEntry.managerId);
        let managerName = '';
        if (managerInfo && managerInfo.length > 0) {
            managerName = managerInfo[0].shortName + '-' + managerInfo[0].longName;
        }
        setManagerDetailsWithOptionalAccount(tradeCaptureDisplayState.tradeEntry.managerId, managerName, false,true);
    }, [tradeCaptureDisplayState.tradeEntry.managerId, viewClicked])

    useEffect(() => {
        if(!viewClicked && isTradeBreak) return;

        let defaultAllocationObj = {
            'managerId': entityAccountsNoSwap.managerId,
            'accountType': "2",
            'allocation': 0.0,
            'commission': 0.0,
            'accruedInterest': 0.0
        }

        let accountsOptionList = accountsOptionsNoSwap
        // PSNG-6208 Trade Rebook - filter only allocated one
        if( !isTradeBreak && tradeCaptureDisplayState.tradeEntry.accountId && tradeCaptureDisplayState.tradeEntry.accountId !=""  ){
            accountsOptionList = accountsOptionsNoSwap.filter(item => item.accountId === tradeCaptureDisplayState.tradeEntry.accountId || (tradeCaptureDisplayState.tradeEntry.migrated && item.oldMappedAccountId == tradeCaptureDisplayState.tradeEntry.accountId))
        }
        let gridData = accountsOptionList.flatMap(item => {
            let finalAllocationObj = [];
            let accountAllocationObj = {...defaultAllocationObj,...{
                    'accountId': tradeCaptureDisplayState.tradeEntry.migrated?item.oldMappedAccountId:item.accountId,
                    'accountName': tradeCaptureDisplayState.tradeEntry.migrated?item.oldMappedAccount+ "-" + item.oldMappedNameLong:item.accountCode + "-" + item.name,
                    'accountCode': tradeCaptureDisplayState.tradeEntry.migrated?item.oldMappedAccount:item.accountCode,
                }}
            if (!isTradeBreak && tradeCaptureDisplayState.tradeEntry.migrated?item.oldMappedAccountId:item.accountId === tradeCaptureDisplayState.tradeEntry.accountId){
                accountAllocationObj = {...accountAllocationObj,...{
                        'accountType': JSON.parse(JSON.stringify(tradeCaptureDisplayState.tradeEntry.accountType)),
                        'allocation': JSON.parse(JSON.stringify(tradeCaptureDisplayState.tradeEntry.quantity)),
                        'commission': JSON.parse(JSON.stringify(tradeCaptureDisplayState.tradeEntry.commission)),
                        'accruedInterest': JSON.parse(JSON.stringify(tradeCaptureDisplayState.tradeEntry.accruedInterest))
                    }}
                finalAllocationObj.push(accountAllocationObj)
            }
            else if (isTradeBreak){
                const allocationsFromTradeBreak = tradeCaptureDisplayState.tradeActivitiesSearch.resData.filter(allocationFromTradeBreak => item.accountId === allocationFromTradeBreak.accountId).map(allocationFromTradeBreak => ({
                    ...accountAllocationObj,
                        'accountType': JSON.parse(JSON.stringify(allocationFromTradeBreak.accountType)),
                        'allocation': JSON.parse(JSON.stringify(allocationFromTradeBreak.quantity)),
                        'commission': JSON.parse(JSON.stringify(allocationFromTradeBreak.commission)),
                        'accruedInterest': JSON.parse(JSON.stringify(allocationFromTradeBreak.accruedInterest)),
                        'tradeBridgeTradeId':JSON.parse(JSON.stringify(allocationFromTradeBreak.tradeBridgeTradeId)),
                        'clientId':JSON.parse(JSON.stringify(allocationFromTradeBreak.clientId)),
                        'cdBlockIdClient':JSON.parse(JSON.stringify(allocationFromTradeBreak.cdBlockIdClient)),
                        'version': JSON.parse(JSON.stringify(allocationFromTradeBreak.version))
                }));
                if (allocationsFromTradeBreak.length > 0)
                    finalAllocationObj.push(...allocationsFromTradeBreak);
                else
                    finalAllocationObj.push(accountAllocationObj);
            }
            else finalAllocationObj.push(accountAllocationObj);
            return finalAllocationObj
        })
        setRowData(gridData)
        setViewClicked(false)
    }, [accountsOptionsNoSwap, viewClicked])

    useEffect(() => {
        getCurrencies()
    }, [])

    useEffect(() => {
        if(tradeCaptureDisplayState.tradeEntry.securityOption =='Y' && tradeCaptureDisplayState.tradeEntry.security) {
            searchSecurityOption();
        }
    }, [tradeCaptureDisplayState.tradeEntry.securityOption])

    useEffect(() => {
        handleSecurityOnBlur()
        handleBrokerOnBlur()
    }, [id])

    useEffect(() => {
        handleBrokerOnBlur()
    }, [accountsOptionsNoSwap])

    useEffect(() => {
        setIsDisabled(handleFormDisable)
    }, [id, tradeCaptureDisplayState.tradeEntry.status, tradeCaptureDisplayState.tradeEntry.dbSource, tradeCaptureDisplayState.tradeEntry.indTradeCancel, tradeCaptureDisplayState.tradeEntry.migrated])

    const handleFormDisable = () =>{
        return (id && id !== 'ACCEPT') || (tradeCaptureDisplayState.tradeEntry.status && tradeCaptureDisplayState.tradeEntry.status !== 'ACCEPT') || tradeCaptureDisplayState.tradeEntry.dbSource === 'TRADING' || tradeCaptureDisplayState.tradeEntry.indTradeCancel === 'C' || tradeCaptureDisplayState.tradeEntry.isTradeBreakReadonly || (tradeCaptureDisplayState.tradeEntry.migrated)
    }

    const handleSecurityOnBlur = (e) => {
        if(tradeCaptureDisplayState.tradeEntry.security) {
            setSecOption('')
            setShowToolTip(false)

            searchSecurity();
            if(tradeCaptureDisplayState.tradeEntry.securityOption =='Y') {
                searchSecurityOption();
            }
        }
    }

    const handleBrokerOnBlur = () => {
        if(tradeCaptureDisplayState.tradeEntry.brokerCode && accountsOptionsNoSwap)
            searchBroker()
    }

    const getCurrencies = () => {
        const onSuccessResponse = (res) => {
            if(res.data) {
                setCurrencies(res.data);
            }
        }

        const onErrorResponse = () => {}

        makeGetRequestNoParams(URL.CURRENCY_LIST_UNIQUE_URL, onSuccessResponse, onErrorResponse)
    }

    const searchSecurity = () => {
        const securityCode = getSecurity()

        const params = {
            "securityCode": securityCode
        }

        const onSuccessResponse = (res) => {
            if(res.data) {
                let tradeCaptureDisplayStateChange = {...tradeCaptureDisplayState};
                tradeCaptureDisplayStateChange['tradeEntry']['securityDescription'] =
                        res.data[0] && res.data[0]['longName'] != null ? res.data[0]['longName'] : ''
                tradeCaptureDisplayStateChange['tradeEntry']['securityCode'] = securityCode ? securityCode.toUpperCase() : '';
                setTradeCaptureDisplayState(tradeCaptureDisplayStateChange);
            }
        }

        const onErrorResponse = (err) => {
            error("Error getting security description")
            console.error("Error on search security: ", err);
        }

        makeGetRequest(URL.SECURITY_SEARCH_URL, params, onSuccessResponse, onErrorResponse)
    }

    const searchSecurityOption = () => {
        const params = {
            "ticker": getSecurity()
        }

        const onSuccessResponse = (res) => {
            if(res.data) {
                let tradeCaptureDisplayStateChange = {...tradeCaptureDisplayState};
                tradeCaptureDisplayStateChange['tradeEntry']['securityOptionList'] = res.data;
                setTradeCaptureDisplayState(tradeCaptureDisplayStateChange);
            }
        }

        const onErrorResponse = (err) => {
            error("Error getting security options")
            console.error("Error on searchSecurityOption: ", err);
        }

        makeGetRequest(URL.SECURITY_SEARCH_OPTIONS_URL, params, onSuccessResponse, onErrorResponse)
    }

    const getSecurity = () => {
        let security = '';
        if (tradeCaptureDisplayState.tradeEntry.security) {
            security = tradeCaptureDisplayState.tradeEntry.security;
        }
        return security.trim();
    }

    const searchBroker = () => {
        let managerId = entityAccountsNoSwap.managerId  ? entityAccountsNoSwap.managerId : tradeCaptureDisplayState.tradeEntry.managerId;
        const data = {
            "brokerCode":tradeCaptureDisplayState.tradeEntry.brokerCode,
            "managerId": managerId
        }

        const onSuccessResponse = (res) => {
            if(res.data) {
                let brokerDescription = res.data['brokerDescription'] ? res.data['brokerCode'].toUpperCase().trim() +"/"+ res.data['brokerDescription'] : ""
                let tradeCaptureDisplayStateChange = {...tradeCaptureDisplayState}
                tradeCaptureDisplayStateChange['tradeEntry']["brokerDescription"] = brokerDescription
                setTradeCaptureDisplayState(tradeCaptureDisplayStateChange);
            }
        }

        const onErrorResponse = () => {}

        makePostRequest(data, URL.BROKER_SEARCH_URL, onSuccessResponse, onErrorResponse)
    }



    const handleOptionOnChange = async (e) => {
        let tradeCaptureDisplayStateChange = {...tradeCaptureDisplayState};
        let checkValue = e.currentTarget.checked ? "Y" : "N";
        setSecOption('')
        setShowToolTip(false)
        tradeCaptureDisplayStateChange['tradeEntry']["securityOption"] = checkValue;
        setTradeCaptureDisplayState(tradeCaptureDisplayStateChange);
    }

    const handleOnChangeNumber = ({ formattedValue, value, floatValue }, name) => {
        const field = name;
        let tradeCaptureDisplayStateChange = {...tradeCaptureDisplayState};
        tradeCaptureDisplayStateChange['tradeEntry'][field] = formattedValue
        setTradeCaptureDisplayState(tradeCaptureDisplayStateChange);
        clearErrors(field)
    }

    const handleOnChange = (e) => {
        const field = e.currentTarget.name;
        const value = e.currentTarget.value;
        const {type, checked} = e.target;

        if(type === 'checkbox' && checked === true) {
            if(Object.keys(errors).length !== 0 && errors.hasOwnProperty('commission')) {
                const {commission, ...otherErrors} = errors;
                setErrors(otherErrors);
            }
        }

        let tradeCaptureDisplayStateChange = {...tradeCaptureDisplayState};
        tradeCaptureDisplayStateChange['tradeEntry'][field] = value

        if (field === "tradeType") {
            setIsDisabledTechShort(value !== "SS");
            setIsTechShortChecked(false);
            tradeCaptureDisplayStateChange['tradeEntry']['techShort'] = 'N';
            clearErrors('techShort');
        }

        setTradeCaptureDisplayState(tradeCaptureDisplayStateChange);
        clearErrors(field)
    }

    const handleOnOverrideCheckboxChange = (e) => {
        const field = e.currentTarget.name;
        let tradeCaptureDisplayStateChange = {...tradeCaptureDisplayState};
        tradeCaptureDisplayStateChange['tradeEntry'][field] = !tradeCaptureDisplayState.tradeEntry.isOverride
        setTradeCaptureDisplayState(tradeCaptureDisplayStateChange);
        clearErrors(field)
    }

    const handleOnChangeTechShort= (e) => {
        const field = e.currentTarget.name;
        const isChecked = e.currentTarget.checked;

        let tradeCaptureDisplayStateChange = {...tradeCaptureDisplayState};

        tradeCaptureDisplayStateChange['tradeEntry'][field] = isChecked ? 'Y' : 'N';

        setIsTechShortChecked(isChecked);
        setTradeCaptureDisplayState(tradeCaptureDisplayStateChange);
        clearErrors(field);
    }

    const handleOnSecurityOptionChange = (e) => {
        const field = e.currentTarget.name;
        let tradeCaptureDisplayStateChange = {...tradeCaptureDisplayState};
        tradeCaptureDisplayStateChange['tradeEntry'][field] = e.currentTarget.value;
        tradeCaptureDisplayStateChange['tradeEntry']['securityCode'] = e.currentTarget.value;
        setTradeCaptureDisplayState(tradeCaptureDisplayStateChange);
        setSecOption(e.currentTarget.value)
        setShowToolTip(true)

        clearErrors(field)
    }

    const handleTradeDateBlur = (e)=>{
        if(e.currentTarget.value === null || e.currentTarget.value.length === 0) {
            setTradeCaptureDisplayState(prevTradeCaptureDisplayState => ({
                ...prevTradeCaptureDisplayState, tradeEntry : {
                    ...prevTradeCaptureDisplayState.tradeEntry, tradeDate: getCurrentDateToDatePickerFormat()
                }
            }));
        }
    }

    const clearErrors = (field) => {
        if(!!errors[field])
            setErrors({...errors, [field]:null});
    }

    useEffect( () => {
        clearErrors("totalAllocation")
    }, [tradeCaptureDisplayState.tradeEntry.totalAllocation])

    useEffect(() => {
        if (rowData.length === 1) {
            const quantity = formatAmount(tradeCaptureDisplayState.tradeEntry.quantity)
            const commission = formatAmount(tradeCaptureDisplayState.tradeEntry.commission)
            const accruedInterest = formatAmount(tradeCaptureDisplayState.tradeEntry.accruedInterest)

            const updatedRowData = rowData.map((row) => {
                return {...row, allocation: quantity, commission: commission, accruedInterest: accruedInterest,};
            });
            setRowData(updatedRowData);
        }
    }, [tradeCaptureDisplayState.tradeEntry.quantity, tradeCaptureDisplayState.tradeEntry.commission, tradeCaptureDisplayState.tradeEntry.accruedInterest]);

    // action can be rebook or submit or undefined.
    const validateForm = () => {
        const { tradeType, security, brokerCode,
            isOverride, tradeDate, settleDate, comments, clientId, totalAllocation,
            fxUSDRate, currency, techShort, isTradeBreak} = tradeCaptureDisplayState.tradeEntry

        const quantity = formatAmount(tradeCaptureDisplayState.tradeEntry.quantity)
        const commission = formatAmount(tradeCaptureDisplayState.tradeEntry.commission)
        const price = formatAmount(tradeCaptureDisplayState.tradeEntry.price)
        const commissionType =  updateCommissionType(tradeCaptureDisplayState.tradeEntry.commissionType)
        let errors = {};

        errors = validateEntityAccountSearch(true,true);

        if(!tradeType)
            errors['tradeType'] = "Trade Type is required";

        if(quantity === 0 || quantity === '' || !quantity)
            errors['quantity'] = "Required field";

        if(security === null || security.length <= 0)
            errors['security'] = "Required field"

        if(parseFloat(price) === 0 || price === '' || !price)
            errors['price'] = "Required field"

        if(brokerCode.length === 0)
            errors['brokerCode']="Required field"
        // remove broker code description check

        if(techShort === 'Y' && tradeType !== 'SS')
            errors['techShort'] = TRADE_ENTRY_TECH_SHORT_TRADE_TYPE_MSG

        let maxTotalComm = 0.0;
        let totalPricePerShare = 0.0;
        let totalCentsPerShare = 0.0;
        if((commission === 0 || commission === '' || !commission) && !isOverride)
            errors['commission'] = "Required field"
        else if(commissionType === "3"){
            totalPricePerShare = quantity * price
            maxTotalComm = (totalPricePerShare * 5) / 100;
            if(parseFloat(commission) > maxTotalComm && !isOverride)
                errors['commission'] = "Invalid value - max. allowed comm 5%"

            if(commission < 1 && (commission !== 0 || commission.trim !== '' || !commission) && !isOverride)
                errors['commission'] = "Invalid value - comm is less than $1"
        }
        else if(commissionType === "1"){
            totalCentsPerShare = (quantity * commission) / 100.00
            totalPricePerShare = quantity * price;
            maxTotalComm = totalPricePerShare * 0.05
            if(totalCentsPerShare > maxTotalComm && !isOverride)
                errors['commission'] = "Invalid value - max. allowed comm 5%"
        }

        if(tradeDate ===null || tradeDate.length === 0) {
            let tradeCaptureDisplayStateChange = {...tradeCaptureDisplayState}
            tradeCaptureDisplayStateChange['tradeEntry']["tradeDate"] = getCurrentDate()
            setTradeCaptureDisplayState(tradeCaptureDisplayStateChange);
        }

        if(totalAllocation <= 0)
            errors['totalAllocation'] = "Please allocate quantity"

        if(totalAllocation != quantity)
            errors['totalAllocation'] = "Allocate and quantity must match"

        let errorsRegex = validateTradeEntryRegex(clientId, tradeType, quantity, security, commissionType,
            commission, price, brokerCode, currency, fxUSDRate, comments)
        if (errorsRegex){
            errors = {...errors, ...errorsRegex}
        }
        return errors
    }

    const validateTradeEntryRegex = (clientId, tradeType, quantity,security,commissionType,commission,price,
           brokerCode, currency, fxUSDRate, comments) => {
        let errors = {}
        // client id
        let match = false
        if(clientId && clientId.length > 0){
            match = validateValueOnRegex(clientId, REGEX_TRADE_ENTRY_CLIENT_ID)
            if (!match){
                errors['clientId'] = TRADE_ENTRY_CLIENT_ID_MSG
            }
        }
        // tradeType
        if(tradeType && tradeType.length > 0){
            match = validateValueOnList(tradeType, LIST_TRADE_ENTRY_TRADE_TYPE)
            if (!match){
                errors['tradeType'] = TRADE_ENTRY_TRADE_TYPE_MSG            }
        }
        // quantity
        if(quantity && quantity.length > 0){
            match = validateValueOnRegex(quantity, REGEX_TRADE_ENTRY_WHOLE_NUMBER)
            if (!match){
                errors['quantity'] = TRADE_ENTRY_WHOLE_NUMBER_MSG
            }
        }
        // security
        if(security && security.length > 0){
            match = validateValueOnRegex(security, REGEX_TRADE_ENTRY_SECURITY_CODE)
            if (!match){
                errors['security'] = TRADE_ENTRY_SECURITY_CODE_MSG
            }
        }

        // commissionType
        if(commissionType && commissionType.length > 0){
            match = validateValueOnRegex(commissionType, REGEX_TRADE_ENTRY_COMMISSION_TYPE)
            if (!match){
                errors['commissionType'] = TRADE_ENTRY_COMMISSION_TYPE_MSG
            }
        }
        // commission
        if(commission && commission.length > 0){
            match = validateValueOnRegex(commission, REGEX_TRADE_ENTRY_DECIMAL_NUMBER)
            if (!match){
                errors['commission'] = TRADE_ENTRY_DECIMAL_NUMBER_MSG
            }
        }
        // price
        if(price && price.length > 0){
            match = validateValueOnRegex(price, REGEX_TRADE_ENTRY_DECIMAL_NUMBER)
            if (!match){
                errors['price'] = TRADE_ENTRY_DECIMAL_NUMBER_MSG
            }
        }
        // brokerCode
        if(brokerCode && brokerCode.length > 0){
            match = validateValueOnRegex(brokerCode, REGEX_TRADE_ENTRY_BROKER_CODE)
            if (!match){
                errors['brokerCode'] = TRADE_ENTRY_BROKER_CODE_MSG
            }
        }
        // currency
        if(currency && currency.length > 0){
            match = validateValueOnRegex(currency, REGEX_TRADE_ENTRY_CURRENCY)
            if (!match){
                errors['currency'] = TRADE_ENTRY_CURRENCY_MSG
            }
        }
        // fxUSDRate
        if(fxUSDRate && fxUSDRate.length > 0){
            match = validateValueOnRegex(fxUSDRate, REGEX_TRADE_ENTRY_DECIMAL_NUMBER)
            if (!match){
                errors['fxUSDRate'] = TRADE_ENTRY_DECIMAL_NUMBER_MSG
            }
        }
        // comments
        if(comments && comments.length > 0){
            match = validateValueOnRegex(comments, REGEX_TRADE_ENTRY_COMMENTS)
            if (!match){
                errors['comments'] = TRADE_ENTRY_COMMENTS_MSG
            }
        }
        //
        return errors;
    }
    const handleOnClear = (e) => {
        e.preventDefault()
        clearTradeSearchAndLoadTradingHome()
        clearEntityAccounts(false, false,true)
        setErrors({})
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        let formErrors = {}
        if (VALIDATION_IN_JS){
            formErrors = validateForm();
        }
        if(Object.keys(formErrors).length > 0) {
            setErrors(formErrors)
            return
        }
        else {

            const params = rowData.filter(item => item.allocation > 0).map(item => {
                return {
                    "accountId": item.accountId,
                    "managerId":entityAccountsNoSwap.managerId,
                    "accountType": item.accountType,
                    "accruedInterest": item.accruedInterest,
                    "commission": item.commission,
                    "quantity": item.allocation,
                    "tradeType": tradeCaptureDisplayState.tradeEntry.tradeType,
                    "securityCode": tradeCaptureDisplayState.tradeEntry.securityOption && tradeCaptureDisplayState.tradeEntry.securityOption === "Y" && tradeCaptureDisplayState.tradeEntry.securityCode && tradeCaptureDisplayState.tradeEntry.securityCode !== ""?tradeCaptureDisplayState.tradeEntry.securityCode:tradeCaptureDisplayState.tradeEntry.security,
                    "price": formatAmount(tradeCaptureDisplayState.tradeEntry.price),
                    "currency": tradeCaptureDisplayState.tradeEntry.currency,
                    "brokerCode": tradeCaptureDisplayState.tradeEntry.brokerCode,
                    "commissionType": tradeCaptureDisplayState.tradeEntry.commissionType,
                    "tradeDate": dateToString(tradeCaptureDisplayState.tradeEntry.tradeDate.toString()),
                    "settleDate": dateToString(tradeCaptureDisplayState.tradeEntry.settleDate.toString()),
                    "comments": tradeCaptureDisplayState.tradeEntry.comments,
                    "clientId": tradeCaptureDisplayState.tradeEntry.clientId,
                    "securityOption": tradeCaptureDisplayState.tradeEntry.securityOption ? tradeCaptureDisplayState.tradeEntry.securityOption : "N",
                    "fxUSDRate":'',
                    "isOverride": tradeCaptureDisplayState.tradeEntry.isOverride,
                    "techShort": tradeCaptureDisplayState.tradeEntry.techShort
                }
            })

            const onSuccessResponse = (res) => {
                if(res.data){
                    let tradeCaptureDisplayStateChange = {...tradeCaptureDisplayState}
                    tradeCaptureDisplayStateChange['tradeEntry']['resData'] = res.data
                    tradeCaptureDisplayStateChange.currentPage = TRADE_CAPTURE_PANEL_ENTRY_RESULT
                    setTradeCaptureDisplayState(tradeCaptureDisplayStateChange);
                }
            }

            const onErrorResponse = (err) => {
                let errorMsg = getAllErrorValuesAsString(err.response.data)
                console.error("Error on creating new Trade:",errorMsg)
                error("Error on creating new Trade")
            }

            makePostRequest(params, URL.TRADES_SAVE_URL, onSuccessResponse, onErrorResponse)
        }
    }

    const updateCommissionType =(commissionType) => {
        let commType = commissionType
        if(commissionType === "Total") {
            commType = "3"
        }
        else if(commissionType === "Rate") {
            commType = "1"
        }
        else if(commissionType === "Basis Points") {
            commType = "5"
        }

        return commType;
    }

    const handleRebook = (e) => {
        e.preventDefault()
        const formErrors = validateForm();
        if(Object.keys(formErrors).length > 0) {
            setErrors(formErrors)
            return
        }
        else {

            const params = rowData.filter(item => item.allocation > 0).map(item => {
                // Default commissionType to '3' (Total) and commission to 0
                // only when both commissionType and item.commission are null/undefined/empty string.
                // When commissionType is null/undefined/empty but item.commission >= 0, preserve existing behaviour.
                const stateCommissionType = tradeCaptureDisplayState.tradeEntry.commissionType;
                const isCommissionTypeAbsent = stateCommissionType == null || stateCommissionType === '';
                const isItemCommissionAbsent = item.commission == null || item.commission === '' || item.commission == 0;
                const shouldDefaultCommission = isCommissionTypeAbsent && isItemCommissionAbsent;

                return {
                    "accountId": item.accountId,
                    "accountType": item.accountType,
                    "accruedInterest": item.accruedInterest,
                    "commission": isItemCommissionAbsent ? 0 : item.commission,
                    "quantity": item.allocation,
                    "tradeType": tradeCaptureDisplayState.tradeEntry.tradeType,
                    "securityCode": tradeCaptureDisplayState.tradeEntry.securityOption && tradeCaptureDisplayState.tradeEntry.securityOption === "Y" && tradeCaptureDisplayState.tradeEntry.securityCode && tradeCaptureDisplayState.tradeEntry.securityCode !== ""?tradeCaptureDisplayState.tradeEntry.securityCode :tradeCaptureDisplayState.tradeEntry.security,
                    "price": formatAmount(tradeCaptureDisplayState.tradeEntry.price),
                    "currency": tradeCaptureDisplayState.tradeEntry.currency,
                    "brokerCode": tradeCaptureDisplayState.tradeEntry.brokerCode,
                    "commissionType": updateCommissionType(shouldDefaultCommission ? "3" : stateCommissionType),
                    "tradeDate": dateToString(tradeCaptureDisplayState.tradeEntry.tradeDate.toString()),
                    "settleDate": dateToString(tradeCaptureDisplayState.tradeEntry.settleDate.toString()),
                    "comments": tradeCaptureDisplayState.tradeEntry.comments,
                    "clientId": isTradeBreak?item.clientId:tradeCaptureDisplayState.tradeEntry.clientId,
                    "openClose":tradeCaptureDisplayState.tradeEntry.openCloseCode,
                    "indTradeCancel":tradeCaptureDisplayState.tradeEntry.indTradeCancel,
                    "fxUSDRate":tradeCaptureDisplayState.tradeEntry.fxUSDRate,
                    "securityOption": tradeCaptureDisplayState.tradeEntry.securityOption ? tradeCaptureDisplayState.tradeEntry.securityOption : "N",
                    "dbSource": tradeCaptureDisplayState.tradeEntry.dbSource,
                    "cdBlockIdClient" : isTradeBreak?item.cdBlockIdClient:tradeCaptureDisplayState.tradeEntry.cdBlockIdClient,
                    "tradeBridgeTradeId": isTradeBreak?item.tradeBridgeTradeId:tradeCaptureDisplayState.tradeEntry.tradeBridgeTradeId,
                    "tradeUploadVersion": isTradeBreak?item.version:tradeCaptureDisplayState.tradeEntry.version,
                    "isOverride": shouldDefaultCommission ? true : tradeCaptureDisplayState.tradeEntry.isOverride
                }
            })

            const onSuccessResponse = (res) => {
                if(res.data){
                    setAmendClicked(true);
                    success("Trade was rebooked successfully")
                    clearEntityAccounts(false, false,true);
                    clearTradeEntry();
                    navigateToPage(Routes.TRADECAPTURE_LIST)
                    if(isTradeBreak)
                        handleBackTradeBreak()
                }
            }

            const onErrorResponse = () => {
                error("Error on rebooking Trade");
            }

            makePostRequest(params, URL.TRADES_REBOOK_URL, onSuccessResponse, onErrorResponse)
        }
    }

    const handleCancel = (e) => {
        e.preventDefault()
        const params = [{
            "tradeUploadId": tradeCaptureDisplayState.tradeEntry.tradeBridgeTradeId,
            "tradeUploadVersion": tradeCaptureDisplayState.tradeEntry.version,
            "dbSource": tradeCaptureDisplayState.tradeEntry.dbSource
        }]

        const onSuccessResponse = (res) => {
            if(res.data){
                success("Trade was cancelled successfully")
                setAmendClicked(true);
                clearEntityAccounts(false, false,true);
                clearTradeEntry();
                navigateToPage(Routes.TRADECAPTURE_LIST)
            }
        }

        const onErrorResponse = (err) => {
            error("Error on cancelling Trade");
        }

        makePostRequest(params, URL.TRADES_CANCEL_URL, onSuccessResponse, onErrorResponse)

    }

    const handleBack = () => {
        clearEntityAccounts(false, false,true);
        clearTradeEntry();
        isTradeBreak ? handleBackTradeBreak() : handleBackTradeList()
    }

    const handleBackTradeList = () => {
        clearEntityAccounts(false, false,true);
        clearTradeEntry();
        navigateToPage(Routes.TRADECAPTURE_LIST)
    }

    const handleBackTradeBreak = () => {
        clearEntityAccounts(false, false,true);
        clearTradeEntry();
        navigateToPage(Routes.TRADECAPTURE_BREAKS)
    }

    const searchNameRenderer = function (props){
        return(<>
            <a className="td-link" href="#" onClick={()=>{}}>{props.value}</a>
        </>);
    }

    const header = function() {
        //Need to investigate why this is called multiple times
        //const status = !tradeCaptureDisplayState.tradeEntry.status ? '' : tradeCaptureDisplayState.tradeEntry.status==="ACCEPT" ? "Active" : tradeCaptureDisplayState.tradeEntry.status;
        const statusMap = {
            "ACCEPT": "Active",
            "PEND": "Error"
        };
        const status = statusMap[tradeCaptureDisplayState.tradeEntry.status] || tradeCaptureDisplayState.tradeEntry.status || '';

        return(
            <>
            <Container fluid>
                <Row>
                    <Col className="px-md-3">
                        <h1>Trade Status: {status}</h1>
                    </Col>

                </Row>

            </Container>
        {tradeCaptureDisplayState.tradeEntry.isTradeBreakReadonly &&
        <Container fluid>
            <Row>
                <Col className="px-md-3">
                    <b className={'error'}><i className="bi bi-exclamation-circle"></i>{tradeCaptureDisplayState.tradeEntry.tradeBreakComments===null?'Trade is being processed or is already amended':tradeCaptureDisplayState.tradeEntry.tradeBreakComments}</b>
                </Col>
            </Row>

        </Container>
        }
        {tradeCaptureDisplayState.tradeEntry.migrated &&
            <Container fluid>
            <Row>
                <Col className="px-md-3">
                    <b className={'error'}><i className="bi bi-exclamation-circle"></i>Inactive trade account - cancel/rebook disabled</b>
                </Col>
            </Row>
            </Container>
        }
        </>
        );
    }

    const controlButtons = function() {
        //Need to investigate why this is called multiple times

        if (isDisabled) {
            return (
                <Form onSubmit={(e) => e.preventDefault()}>
                    <Row className="py-3">
                        <Col lg={10} className="d-none d-md-block"></Col>
                        <Col xs={12} sm={12} md={2} className="pt-2">
                            <button className="btn btn-block td-btn-secondary-clear" onClick={() => handleBack()}>Back
                            </button>
                        </Col>
                    </Row>
                </Form>
            );
        }
        else if (isTradeBreak) {
            return (
                <Row className="py-3">
                    <Col lg={8} className="d-none d-md-block"></Col>
                    <Col xs={6} sm={6} md={2} className="pt-2">
                        <button className="btn btn-block td-btn-secondary-clear"
                                onClick={() => handleBack()}>Back
                        </button>
                    </Col>
                    <Col xs={6} sm={6} md={2} className="pt-2">
                        <button disabled={disableSubmit} className="btn btn-block td-btn-primary-light" type={'submit'}
                                onClick={handleRebook}>Submit
                        </button>
                    </Col>
                </Row>
            );
        }
        else if (id === 'ACCEPT') {
            return (
                <Row className="py-3">
                    <Col md={6} className="d-none d-md-block"></Col>
                    <Col xs={4} sm={4} md={2} className="pt-2">
                        <button className="btn btn-block td-btn-secondary-clear" onClick={() => handleBack()}>Back
                        </button>
                    </Col>
                    <Col xs={4} sm={4} md={2} className="pt-2">
                        <button disabled={disableSubmit} className="btn btn-block td-btn-CTA"
                                onClick={handleCancel}>Cancel Trade
                        </button>
                    </Col>
                    <Col xs={4} sm={4} md={2} className="pt-2">
                        <button disabled={disableSubmit} className="btn btn-block td-btn-primary-light" type={'submit'}
                                onClick={handleRebook}>Rebook
                        </button>
                    </Col>
                </Row>
            );
        }


        else {
            return (
                <Row className="py-3">
                    <Col lg={8} className="d-none d-md-block"></Col>
                    <Col xs={6} sm={6} md={2} className="pt-2">
                        <button className="btn btn-block td-btn-secondary-clear" href="#" onClick={(event) => {
                            setDisableSubmit(false);
                            handleOnClear(event)
                        }}>Clear
                        </button>
                    </Col>
                    <Col xs={6} sm={6} md={2} className="pt-2">
                        <button className="btn btn-block td-btn-primary-light" type={'submit'}
                                onClick={handleSubmit}>Submit
                        </button>
                    </Col>
                </Row>
            );
        }
    }

    const tabletFilter = function() {

        return(
            <Row className="pb-2 pl-0">
                <Col xs={12} sm={10} md={4} className="p-0">
                    <EntityAccountsComponent isReadOnly={tradeCaptureDisplayState.tradeEntry.managerId !== ""} hideSwapLob={true} />
                </Col>
            </Row>
        );

    }



    return (<>

        <Container fluid>
            <Row className="justify-content-start navbar td-" style={{paddingTop:20, paddingBottom:10}}>
                <Col style={{paddingLeft: 0}} xs={"auto"}>
                    {header()}
                </Col>
            </Row>
            <Row>
                <Col>
                    {tabletFilter()}
                </Col>
            </Row>
            <Row>
                <Col>
                    <hr className="td-thin-divider-line-2 pt-3"></hr>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form onSubmit={(e) => e.preventDefault()}>
                        <Form.Row>
                            <Col xs={12} sm={3} md={3} xl={1} lg={4} className="pt-0">
                                <Form.Group controlId="formGridTradeType" className={'td-select'}>
                                    <Form.Label>Trade Type *</Form.Label>
                                    <Form.Control disabled={isDisabled} as="select" name={"tradeType"} value={tradeCaptureDisplayState.tradeEntry.tradeType} onChange={handleOnChange} isInvalid={!!errors.tradeType}>{
                                        tradeTypeJSON.map(trade => <option key={trade.id} value={trade.id}>{trade.name}</option>)}
                                    </Form.Control>
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.tradeType}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col xs={12} sm={2} md={2} xl={1} lg={2} className="pt-0">
                                <Form.Group controlId="formGridQuantity" className="pt-0">
                                    <Form.Label ref={quantityLabelRef}>Quantity *</Form.Label> {isTradeBreak && <LabelOverLay target={quantityLabelRef} show={highlightTradeEntryFields.quantity} message={missMatched}/>}
                                    <NumberFormat
                                        disabled={isDisabled} value={tradeCaptureDisplayState.tradeEntry.quantity}
                                        isAllowed={(values) => {
                                            const { value } = values;
                                            return value <= MAX_LIMIT_TRADE_QUANTITY;
                                        }}
                                        allowNegative={false}
                                        thousandSeparator={true}      // Add commas as thousand separators
                                        decimalScale={0}              // Two decimal places for price
                                        fixedDecimalScale={true}       // Always show two decimal places
                                        name="quantity"                  // Set the name to "price"
                                        id="quantity"
                                        onValueChange={({ formattedValue, value, floatValue }) =>
                                            handleOnChangeNumber({ formattedValue, value, floatValue }, 'quantity')
                                        }
                                        className={!!errors.quantity?"form-control is-invalid":"form-control"}
                                    />

                                    <Form.Control.Feedback type={"invalid"} style={{display: !!errors.quantity?'block':'none'}}><b><i className="bi bi-exclamation-circle"></i>{errors.quantity}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col xs={3} sm={2} md={2} xl={1} lg={1} className="pt-0">
                                <Form.Group controlId="formGridOptionCheckbox">
                                    <Form.Label>&nbsp;</Form.Label>
                                    <Form.Check disabled={isDisabled} type="checkbox" label="Option" value={tradeCaptureDisplayState.tradeEntry.securityOption} name={"securityOption"}
                                                onChange={handleOptionOnChange}
                                                defaultChecked={tradeCaptureDisplayState.tradeEntry.securityOption && tradeCaptureDisplayState.tradeEntry.securityOption == 'Y' ? true : false}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={8} sm={5} md={5} lg={4} xl={2} className="pt-0">
                                <Form.Group controlId="formGridTechShortCheckbox">
                                    <Form.Label>Tech Short</Form.Label>
                                    <div
                                        className="td-colour-bg-4"
                                        style={{paddingTop: 2, paddingBottom: 5, paddingLeft: 15, background: "#f2f2f7",
                                            pointerEvents: isDisabledTechShort ? "none" : "auto", opacity: isDisabledTechShort ? 0.5 : 1
                                        }}>
                                        <Form.Check
                                            type="checkbox"
                                            checked={isTechShortChecked}
                                            label="Deem to own Short Sale Exempt"
                                            name={"techShort"}
                                            onChange={handleOnChangeTechShort}
                                            defaultChecked={tradeCaptureDisplayState.tradeEntry.techShort == 'N' ? false : true}
                                        />
                                    </div>
                                    {!!errors.techShort &&
                                        <div className="invalid-feedback" style={{display: 'block'}}>
                                            <b><i className="bi bi-exclamation-circle"></i>{errors.techShort}</b>
                                        </div>
                                    }
                                </Form.Group>
                            </Col>
                            <Col xs={6} sm={6} md={6} xl={1} lg={3} className="pt-0">
                                <Form.Group controlId="formGridSecurity">
                                    <Form.Label ref={target}>Security *</Form.Label>
                                    <Form.Control disabled={isDisabled} placeholder="ABCD" name={"security"} value={tradeCaptureDisplayState.tradeEntry.security}
                                                  onChange={handleOnChange}
                                                  onBlur={handleSecurityOnBlur}
                                                  isInvalid={!!errors.security}
                                    />
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.security}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>



                            <Col xs={6} sm={6} md={6} xl={2} lg={3} className={"pt-0"}>
                                <Form.Group controlId="formGridSecurityDescription">
                                    <Form.Label>Security Description</Form.Label>
                                    {tradeCaptureDisplayState.tradeEntry.securityOption && tradeCaptureDisplayState.tradeEntry.securityOption == 'Y' ?
                                        <Form.Control disabled={isDisabled} as="select" name={"securityOptionSelected"} value={tradeCaptureDisplayState.tradeEntry.securityOptionSelected} onChange={handleOnSecurityOptionChange}>
                                            <option value="">Select</option>{
                                            tradeCaptureDisplayState.tradeEntry.securityOptionList.map(option => <option key={option['occSymbol']} value={option['occSymbol']}>{option['securityDes']}</option>)
                                        }
                                        </Form.Control>
                                        :
                                        <Form.Control placeholder="Read Only" value={tradeCaptureDisplayState.tradeEntry.securityDescription} disabled/>}


                                </Form.Group>
                            </Col>


                            <Col xs={6} sm={4} md={4} xl={2} lg={2} className="pt-0">
                                <Form.Group controlId="formGridPrice">
                                    <Form.Label ref={priceLabelRef}>Price *</Form.Label> {isTradeBreak && <LabelOverLay target={priceLabelRef} show={highlightTradeEntryFields.price} message={missMatched}/>}
                                    <NumberFormat
                                        disabled={isDisabled} value={tradeCaptureDisplayState.tradeEntry.price}
                                        isAllowed={(values) => {
                                            const { value } = values;
                                            return value <= MAX_LIMIT_TRADE_AMOUNT;
                                        }}
                                        allowNegative={false}
                                        thousandSeparator={true}      // Add commas as thousand separators
                                        decimalScale={5}              // Two decimal places for price
                                        fixedDecimalScale={true}       // Always show two decimal places
                                        name="price"                  // Set the name to "price"
                                        id="price"
                                        onValueChange={({ formattedValue, value, floatValue }) =>
                                            handleOnChangeNumber({ formattedValue, value, floatValue }, 'price')
                                        }
                                        allowEmptyFormatting className={!!errors.price?"form-control is-invalid":"form-control"}
                                    />
                                    <Form.Control.Feedback type={"invalid"} style={{display: !!errors.price?'block':'none'}}><b><i className="bi bi-exclamation-circle"></i>{errors.price}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col xs={6} sm={4} md={4} xl={1} lg={2} className="pt-0">
                                <Form.Group controlId="formGridCurrency" className={'td-select'}>
                                    <Form.Label>Currency *</Form.Label>
                                    <Form.Control disabled={isDisabled} as="select" name={"currency"} value={tradeCaptureDisplayState.tradeEntry.currency} onChange={handleOnChange}>
                                        {
                                            currencies.map(item =>
                                                <option key={item['isoCurrencyCode']} value={item['isoCurrencyCode']}>{item['isoCurrencyCode']}</option>
                                            )
                                        }
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={4} md={4} lg={1} xl={1} className="pt-0">
                                <Form.Group controlId="formGridFxRate">
                                    <Form.Label>Fx Rate</Form.Label>
                                    <Form.Control disabled={isDisabled} pattern={REGEX_DECIMAL_MATCH} placeholder="1.00" name={"fxUSDRate"} value={tradeCaptureDisplayState.tradeEntry.fxUSDRate} onChange={handleOnChange}
                                                  isInvalid={!!errors.fxUSDRate}/>
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.fxUSDRate}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={6} sm={5} md={5} xl={1} lg={2} className="pt-0">

                                <Form.Group controlId="formGridBrokerCode">
                                    <Form.Label ref={brokerCodeLabelRef}>Broker Code *</Form.Label> {isTradeBreak && <LabelOverLay target={brokerCodeLabelRef} show={highlightTradeEntryFields.execBroker} message={missMatched}/>}
                                    <Form.Control disabled={isDisabled || !entityAccountsNoSwap.managerId} placeholder="ABCD" name={"brokerCode"} value={tradeCaptureDisplayState.tradeEntry.brokerCode} onChange={handleOnChange}
                                                  onBlur={handleBrokerOnBlur}
                                                  isInvalid={!!errors.brokerCode}
                                    />
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.brokerCode}</b></Form.Control.Feedback>
                                </Form.Group>

                            </Col>
                            <Col xs={6} sm={7} md={7} xl={1} lg={2} className="pt-0">
                                <Form.Group controlId="formGridBroker">
                                    <Form.Label>Broker</Form.Label>
                                    <Form.Control placeholder="Read Only" value={tradeCaptureDisplayState.tradeEntry.brokerDescription} disabled/>
                                </Form.Group>
                            </Col>


                            <Col xs={6} sm={2} md={2} xl={1} lg={2} className="pt-0">
                                <Form.Group controlId="formGridCommType" className={'td-select'}>
                                    <Form.Label>Comm Type *</Form.Label>
                                    <Form.Control disabled={isDisabled} as="select" name={"commissionType"} value={tradeCaptureDisplayState.tradeEntry.commissionType} onChange={handleOnChange}>
                                        {
                                            commissionTypeJSON.map(item =>
                                                <option value={item.id}>{item.name}</option>)
                                        }
                                    </Form.Control>
                                </Form.Group>
                            </Col>

                            <Col xs={6} sm={2} md={2} lg={2} xl={1} className="pt-0">
                                <Form.Group controlId="formGridComm">
                                    <Form.Label ref={commissionLabelRef}>Comm *</Form.Label>{isTradeBreak && <LabelOverLay target={commissionLabelRef} show={highlightTradeEntryFields.commission} message={missMatched}/>}
                                    <NumberFormat
                                        disabled={isDisabled} value={tradeCaptureDisplayState.tradeEntry.commission}
                                        isAllowed={(values) => {
                                            const { value } = values;
                                            return value <= MAX_LIMIT_TRADE_AMOUNT;
                                        }}
                                        allowNegative={false}
                                        thousandSeparator={true}      // Add commas as thousand separators
                                        decimalScale={5}              // Two decimal places for price
                                        fixedDecimalScale={true}       // Always show two decimal places
                                        name="commission"                  // Set the name to "price"
                                        id="commission"
                                        onValueChange={({ formattedValue, value, floatValue }) =>
                                            handleOnChangeNumber({ formattedValue, value, floatValue }, 'commission')
                                        }
                                        allowEmptyFormatting className={!!errors.commission?"form-control is-invalid":"form-control"}
                                    />
                                    <Form.Control.Feedback type={"invalid"} style={{display: !!errors.commission?'block':'none'}}><b><i className="bi bi-exclamation-circle"></i>{errors.commission}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={4} md={4} lg={4} xl={1} className="pt-0">
                                <Form.Group controlId="formGridTradeDate">
                                    <Form.Label ref={tradeDateLabelRef}>Trade Date *</Form.Label> {isTradeBreak && <LabelOverLay target={tradeDateLabelRef} show={highlightTradeEntryFields.tradeDate} message={missMatched}/>}
                                    <Form.Control disabled={isDisabled} type="date" name={"tradeDate"} value={tradeCaptureDisplayState.tradeEntry.tradeDate} onChange={handleOnChange}
                                                  onBlur={handleTradeDateBlur} isInvalid={!!errors.tradeDate}/>
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.tradeDate}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={4} md={4} lg={4} xl={1} className="pt-0">
                                <Form.Group controlId="formGridSettleDate">
                                    <Form.Label ref={settleDateLabelRef}>Settle Date</Form.Label> {isTradeBreak && <LabelOverLay target={settleDateLabelRef} show={highlightTradeEntryFields.settleDate} message={missMatched}/>}
                                    <Form.Control disabled={isDisabled} type="date" name={"settleDate"} value={tradeCaptureDisplayState.tradeEntry.settleDate} onChange={handleOnChange}
                                                  isInvalid={!!errors.settleDate}/>
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.settleDate}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={6} sm={2} md={2} lg={1} xl={1} className="pt-0">
                                <Form.Group controlId="formGridAccInt">
                                    <Form.Label ref={interestLabelRef}>Acc Int</Form.Label>{isTradeBreak && <LabelOverLay target={interestLabelRef} show={highlightTradeEntryFields.interest} message={missMatched}/>}
                                    <NumberFormat
                                        disabled={isDisabled} value={tradeCaptureDisplayState.tradeEntry.accruedInterest??0}
                                        isAllowed={(values) => {
                                            const { value } = values;
                                            return value <= MAX_LIMIT_TRADE_AMOUNT;
                                        }}
                                        allowNegative={false}
                                        placeholder={"0.00"}
                                        thousandSeparator={true}      // Add commas as thousand separators
                                        decimalScale={5}              // Two decimal places for price
                                        fixedDecimalScale={true}       // Always show two decimal places
                                        name="accruedInterest"                  // Set the name to "price"
                                        id="accruedInterest"
                                        onValueChange={({ formattedValue, value, floatValue }) =>
                                            handleOnChangeNumber({ formattedValue, value, floatValue }, 'accruedInterest')
                                        }
                                        allowEmptyFormatting className={!!errors.accruedInterest?"form-control is-invalid":"form-control"}
                                    />
                                    <Form.Control.Feedback type={"invalid"} style={{display: !!errors.accruedInterest?'block':'none'}}><b><i className="bi bi-exclamation-circle"></i>{errors.accruedInterest}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={6} sm={5} md={5} lg={6} xl={2} className="pt-0">
                                <Form.Group controlId="formGridComments">
                                    <Form.Label>Comments</Form.Label>
                                    <Form.Control disabled={isDisabled} placeholder="" name={"comments"} value={tradeCaptureDisplayState.tradeEntry.comments} onChange={handleOnChange}
                                                  isInvalid={!!errors.comments}/>
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.comments}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={5} md={5} lg={2} xl={1} className="pt-0">
                                <Form.Group controlId="formGridClientID">
                                    <Form.Label>Client ID</Form.Label>
                                    <Form.Control disabled={isDisabled} placeholder="1" name={"clientId"} value={tradeCaptureDisplayState.tradeEntry.clientId} onChange={handleOnChange}
                                                  isInvalid={!!errors.clientId}/>
                                    <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.clientId}</b></Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={5} md={5} lg={4} xl={2} className="pt-0">
                                <Form.Group controlId="formGridOverrideCheckbox">
                                    <Form.Label>Override</Form.Label>
                                    <div className="td-colour-bg-4" style={{paddingTop: 2, paddingBottom:5, paddingLeft: 15, background: "#f2f2f7"}}>
                                        <Form.Check  disabled={isDisabled} type="checkbox" checked={tradeCaptureDisplayState.tradeEntry.isOverride} value={tradeCaptureDisplayState.tradeEntry.isOverride} label="Commission validation rules." name={"isOverride"} onChange={handleOnOverrideCheckboxChange}/>
                                    </div>
                                </Form.Group>
                            </Col>

                        </Form.Row>
                    </Form>
                </Col>
            </Row>

            <Row>
                <Col>
                    <div
                        ref={myGrid}
                        id="myGrid"
                        className="ag-theme-alpine trade-group-grid">
                        <AgGridReact
                            frameworkComponents={{
                                allocationRenderer: searchNameRenderer,
                                accountTypeRenderer: AccountTypeRenderer,
                                actionsRenderer: ActionsRenderer,
                            }}
                            paginationPageSize={DEFAULT_GRID_PAGINATION_SIZE}
                            autoGroupColumnDef={{
                                minWidth: 300,
                                cellRendererParams: {
                                    innerRenderer: (params) => {
                                        if (params.node.footer) {
                                            const isRootLevel = params.node.level === -1;
                                            if (isRootLevel) {
                                                return `<span style={{"color":"navy","fontWeight":"bold"}}><B>Total</B></span>`;
                                            }
                                            return `<span style={{"color":"navy"}}>Sub Total ${params.value}</span>`;
                                        }
                                        return params.value;
                                    },
                                },
                            }}
                            domLayout={"autoHeight"}
                            groupDefaultExpanded={'1'}
                            enableRowGroup={true}
                            groupIncludeTotalFooter={true}
                            suppressDragLeaveHidesColumns={true}
                            suppressMakeColumnVisibleAfterUnGroup={true}
                            suppressModelUpdateAfterUpdateTransaction={true}
                            suppressScrollOnNewData={true}
                            suppressAggFuncInHeader={true}
                            allowShowChangeAfterFilter={false}
                            rowGroupPanelShow={'never'}
                            showOpenedGroup={true}
                            groupHideOpenParents={false}
                            groupSuppressBlankHeader={true}
                            enableSorting={true}
                            enableFilter={false}
                            defaultColDef={defaultColDef}
                            columnDefs={updatedColumnDefs}
                            columnTypes={columnTypes}
                            rowData={rowData}
                            animateRows={true}
                            autoGroupColumnDef={autoGroupColumnDef}
                        >
                        </AgGridReact>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col xs={0} lg={4} className="px-0"></Col>
                <Col xs={10} lg={3} className="pl-0 pt-0">
                    <Form.Group controlId="formTotalAllocation" className="pt-0 pl-3 pl-lg-0 mr-5 pr-5">
                        <Form.Control type={"hidden"} isInvalid={!!errors.totalAllocation} />
                        <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{errors.totalAllocation}</b></Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col></Col>
            </Row>
            {controlButtons()}
        </Container>

    </>);

}